import React from "react";
import { Routes, Route } from "react-router-dom";
import ProductionDashboard from "../production/ProductionDashboard";
import MainLayout from "../dashboard/main/MainLayout";
import ProductionSchedule from "../dashboard/production/ProductionSchedule";
import IssuesList from "../dashboard/production/Issues/IssuesList";
import IssueDetails from "../dashboard/production/Issues/IssueDetails";
import ReportIssue from "../dashboard/production/Issues/ReportIssue";
import GuideList from "../dashboard/production/Guides/GuideList";
import Dashboard from "../dashboard/production/Guides/Dashboard";
import EditGuideDashboard from "../dashboard/production/Guides/EditGuideDashboard";
import FlowchartEditor from "../dashboard/production/Guides/FlowchartEditor";
import ProductionHistory from "../dashboard/production/ProductionHistory/ProductionHistory";
import EditIssue from "../dashboard/production/Issues/EditIssue";
import FlowchartEditorGuide from "../dashboard/production/Guides/FlowchartEditorGuide";
import FlowchartEditorBuild from "../dashboard/production/Guides/FlowchartEditorBuild";
import SchedulerDashboard from "../dashboard/production/scheduler/ScheduleDashboard";
import DashboardSchedule from "../dashboard/production/scheduler/Dashboard";
import AddGuideDashboard from "../dashboard/production/Guides/AddGuideDashboard";
const productionDashboard = () => (
  <>
    <Route
      path="/dashboard/guide/flowchart-editor"
      element={<FlowchartEditor />}
    />
    <Route
      path="/dashboard/guide/flowchart-editor-guide"
      element={<FlowchartEditorGuide />}
    />
    <Route
      path="/dashboard/guide/flowchart-editor-build"
      element={<FlowchartEditorBuild />}
    />
    <Route path="/dashboard" element={<MainLayout />}>
      <Route
        path="/dashboard/production/schedule"
        element={<SchedulerDashboard />}
      />
      <Route
        path="/dashboard/production/schedule/schedule-details"
        element={<DashboardSchedule />}
      />

      <Route path="/dashboard/production/issues" element={<IssuesList />} />
      <Route
        path="/dashboard/production/issues/issue-details"
        element={<IssueDetails />}
      />
      <Route
        path="/dashboard/production/issues/report-issue"
        element={<ReportIssue />}
      />
      <Route
        path="/dashboard/production/issues/edit-issue"
        element={<EditIssue />}
      />
      <Route path="/dashboard/guide/guide-list" element={<GuideList />} />
      <Route path="/dashboard/guide/guide-show" element={<Dashboard />} />
      <Route
        path="/dashboard/guide/edit-guide"
        element={<EditGuideDashboard />}
      />
      <Route path="/dashboard/guide/add-guide" element={<AddGuideDashboard />} />

      <Route
        path="/dashboard/production/production-history"
        element={<ProductionHistory />}
      />
    </Route>
  </>
);

export default productionDashboard;
